import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import dropdown from './dropdown/dropdown.js'
import grid from './grid.js'
import library from './library.js'

export default contract({
  dropdown,
  grid: array([
    grid
  ]),
  library: array([
    library
  ])
})